module.exports = __webpack_public_path__ + "static/media/16.872e642a.jpg";